export const MMKVStoreKeyMap = {
  appSettings: 'appSettings',
  userProfile: 'userProfile',
  resumableFeedStore: 'resumableFeeds',
  appInstancesStore: 'appInstancesStore',
  weatherStore: 'weatherStore',
  cropPreferenceStore: 'cropPreferenceStore',
  resumableQnaStore: 'resumableQna',
  qnaFeedStore: 'qnaFeedStore',
  eventStore:'eventStore',
  feedStore:'feedStore',
  liveStreamStore: 'liveStreamStore',
  discoveryStore: 'discoveryStore',
  agriNewsStore:'agriNewsStore'
};
